import apiService from './apiService';

export interface PaymentMethod {
  id?: string;
  name: string;
  fixedFees: number;
  variableFees: number;
  taxPercentage: number;
  linkedAccountId: string;
  linkedAccount?: any;
  linkedAccountName?: string;
  linkedServiceProductId?: string | any;
  linkedServiceProductName?: string;
  authorizedUsers?: any[];
  authorizedUserIds?: string[];
  authorizedUserNames?: string[];
  isActive: boolean;
}

const API_URL = '/finance/payment-methods';

// الحصول على جميع طرق الدفع
export const getAllPaymentMethods = async (): Promise<PaymentMethod[]> => {
  return await apiService.get<PaymentMethod[]>(API_URL);
};

// الحصول على طريقة دفع محددة
export const getPaymentMethodById = async (id: string): Promise<PaymentMethod> => {
  return await apiService.get<PaymentMethod>(`${API_URL}/${id}`);
};

// إنشاء طريقة دفع جديدة
export const createPaymentMethod = async (paymentMethodData: Partial<PaymentMethod>): Promise<PaymentMethod> => {
  console.log('Creating payment method with data:', paymentMethodData);
  // تخطيط الحقول بشكل صحيح لتتناسب مع الباك إند
  const mappedData = {
    name: paymentMethodData.name,
    fixedFees: paymentMethodData.fixedFees,
    variableFees: paymentMethodData.variableFees,
    taxPercentage: paymentMethodData.taxPercentage,
    linkedAccountId: paymentMethodData.linkedAccountId || paymentMethodData.linkedAccount,
    linkedServiceProductId: paymentMethodData.linkedServiceProductId,
    authorizedUsers: paymentMethodData.authorizedUserIds || paymentMethodData.authorizedUsers || [],
    isActive: paymentMethodData.isActive
  };
  console.log('Mapped data for API with authorizedUsers:', mappedData.authorizedUsers);
  return await apiService.post<PaymentMethod>(API_URL, mappedData);
};

// تحديث طريقة دفع
export const updatePaymentMethod = async (id: string, paymentMethodData: Partial<PaymentMethod>): Promise<PaymentMethod> => {
  console.log('Updating payment method with id:', id, 'data:', paymentMethodData);
  // تخطيط الحقول بشكل صحيح لتتناسب مع الباك إند
  const mappedData = {
    name: paymentMethodData.name,
    fixedFees: paymentMethodData.fixedFees,
    variableFees: paymentMethodData.variableFees,
    taxPercentage: paymentMethodData.taxPercentage,
    linkedAccountId: paymentMethodData.linkedAccountId || paymentMethodData.linkedAccount,
    linkedServiceProductId: paymentMethodData.linkedServiceProductId,
    authorizedUsers: paymentMethodData.authorizedUserIds || paymentMethodData.authorizedUsers || [],
    isActive: paymentMethodData.isActive
  };
  console.log('Mapped data for API with authorizedUsers:', mappedData.authorizedUsers);
  return await apiService.put<PaymentMethod>(`${API_URL}/${id}`, mappedData);
};

// حذف طريقة دفع
export const deletePaymentMethod = async (id: string): Promise<void> => {
  await apiService.delete(`${API_URL}/${id}`);
};

// تغيير حالة طريقة الدفع (تفعيل/تعطيل)
export const togglePaymentMethodStatus = async (id: string, isActive: boolean): Promise<PaymentMethod> => {
  return await apiService.patch<PaymentMethod>(`${API_URL}/${id}/status`, { isActive });
};

// الحصول على طرق الدفع المتاحة للمستخدم الحالي
export const getAuthorizedPaymentMethods = async (): Promise<PaymentMethod[]> => {
  return await apiService.get<PaymentMethod[]>(`${API_URL}/active`);
};

// الحصول على طرق الدفع النشطة للمستخدم الحالي
export const getActivePaymentMethodsForCurrentUser = async (): Promise<PaymentMethod[]> => {
  return await apiService.get<PaymentMethod[]>(`${API_URL}/active`);
};